import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Renderer2,
    SimpleChanges,
} from '@angular/core';

@Directive({
    selector: '[multiHandleRangeSlider]',
})
export class RangeSlideDirective implements OnInit {
    @Input('defaultValues') defaultValues;
    @Input('relevantValues') relevantValues;
    @Input('newSelectionValues') newSelectionValues;
    @Input('oldSelectionValues') oldSelectionValues;
    @Input('reset') reset;

    @Output()
    onSlidingEvent: EventEmitter<any> = new EventEmitter<any>();

    root = document.querySelector(':root');

    slider = this.renderer.createElement('div');
    track = this.renderer.createElement('div');
    range = this.renderer.createElement('div');
    relevant_range = this.renderer.createElement('div');
    rel_guide = this.renderer.createElement('div');

    userSelection = false;
    selected_range_min = this.renderer.createElement('div');
    selected_range_max = this.renderer.createElement('div');

    thumb_left = this.renderer.createElement('div');
    thumb_right = this.renderer.createElement('div');
    range_left = this.renderer.createElement('input');
    range_right = this.renderer.createElement('input');

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2 //private control: NgControl
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes) {
            if (changes.reset && changes.reset.currentValue == true) {
                this.userSelection = false;
                this.ngOnInit();
            }

            if (changes.relevantValues) {
                this.relevantValues = changes.relevantValues.currentValue;
                if (this.relevantValues.min == this.newSelectionValues.min) {
                    this.range_left.value = this.relevantValues.min;
                }
                if (this.relevantValues.max == this.newSelectionValues.max) {
                    this.range_right.value = this.relevantValues.max;
                }
            }

            if (changes.newSelectionValues) {
                this.newSelectionValues =
                    changes.newSelectionValues.currentValue;
                this.range_left.value = this.newSelectionValues.min;
                this.range_right.value = this.newSelectionValues.max;
            }
            this.updateSliderData();
        }
    }

    ngOnInit() {
        this.updateSliderData();

        this.renderer.listen(this.range_left, 'input', (event) => {
            this.userSelection = true;

            this.thumb_right.style.zIndex = 4;
            this.thumb_left.style.zIndex = 5;
            this.range_right.style.zIndex = 4;
            this.range_left.style.zIndex = 5;

            let min = +event.target.min;
            let max = +event.target.max;
            let position = +event.target.value;

            if (position >= this.range_right.value) {
                this.thumb_left.setAttribute(
                    'data-min',
                    this.range_right.value
                );
                var percent =
                    ((this.range_right.value - min) / (max - min)) * 100;
                this.thumb_left.style.left = percent + '%';
                this.updateLeftPos(this.range_right.min);

                this.selected_range_min.setAttribute(
                    'data-selected-min',
                    this.range_right.min
                );
                this.selected_range_min.style.left = percent + '%';

                this.range.style.left = percent + '%';
                this.range_left.value = this.range_right.value;
                event.preventDefault();
                return false;
            }

            if (position <= this.relevantValues.min) {
                this.thumb_left.setAttribute(
                    'data-min',
                    this.relevantValues.min
                );
                var percent =
                    ((this.relevantValues.min - min) / (max - min)) * 100;
                this.thumb_left.style.left = percent + '%';
                this.updateLeftPos(this.relevantValues.min);

                this.selected_range_min.setAttribute(
                    'data-selected-min',
                    this.relevantValues.min
                );
                this.selected_range_min.style.left = percent + '%';

                this.range.style.left = percent + '%';
                this.range_left.value = this.relevantValues.min;
                event.preventDefault();
                return false;
            }

            this.thumb_left.setAttribute('data-min', +event.target.value);
            var percent = ((position - min) / (max - min)) * 100;
            this.thumb_left.style.left = percent + '%';
            this.range.style.left = percent + '%';
            this.updateLeftPos(+event.target.value);

            this.selected_range_min.setAttribute(
                'data-selected-min',
                +event.target.value
            );
            this.selected_range_min.style.left = percent + '%';
        });

        this.renderer.listen(this.range_right, 'input', (event) => {
            this.userSelection = true;

            this.thumb_left.style.zIndex = 4;
            this.thumb_right.style.zIndex = 5;
            this.range_left.style.zIndex = 4;
            this.range_right.style.zIndex = 5;

            let min = +event.target.min;
            let max = +event.target.max;
            let position = +event.target.value;

            if (position <= this.range_left.value) {
                this.thumb_right.setAttribute(
                    'data-max',
                    this.range_left.value
                );
                var percent =
                    ((this.range_left.value - min) / (max - min)) * 100;
                this.thumb_right.style.right = 100 - percent + '%';

                this.selected_range_max.setAttribute(
                    'data-selected-max',
                    this.range_left.value
                );
                this.selected_range_max.style.right = 100 - percent + '%';

                this.range.style.right = 100 - percent + '%';
                this.range_right.value = this.range_left.value;

                event.preventDefault();
                return false;
            }

            if (position >= this.relevantValues.max) {
                var percent =
                    ((this.relevantValues.max - min) / (max - min)) * 100;
                this.thumb_right.setAttribute(
                    'data-max',
                    this.relevantValues.max
                );
                this.thumb_right.style.right = 100 - percent + '%';

                this.selected_range_max.setAttribute(
                    'data-selected-max',
                    this.relevantValues.max
                );
                this.selected_range_max.style.right = 100 - percent + '%';

                this.range.style.right = 100 - percent + '%';
                this.range_right.value = this.relevantValues.max;
                event.preventDefault();
                return false;
            }

            this.thumb_right.setAttribute('data-max', +event.target.value);
            var percent = ((position - min) / (max - min)) * 100;
            this.thumb_right.style.right = 100 - percent + '%';
            this.range.style.right = 100 - percent + '%';

            this.selected_range_max.setAttribute(
                'data-selected-max',
                +event.target.value
            );
            this.selected_range_max.style.right = 100 - percent + '%';
        });

        this.renderer.listen(this.range_left, 'change', (event) => {
            let sliderValue = {
                min: this.range_left.value,
                max: this.range_right.value,
                changed: 'min',
            };

            this.updateLeftPos(this.range_left.value);

            this.renderer.setAttribute(
                this.selected_range_min,
                'data-selected-min',
                this.range_left.value
            );

            this.onSlidingEvent.emit(sliderValue);
        });

        this.renderer.listen(this.range_right, 'change', (event) => {
            let sliderValue = {
                min: this.range_left.value,
                max: this.range_right.value,
                changed: 'max',
            };

            this.renderer.setAttribute(
                this.selected_range_max,
                'data-selected-max',
                this.range_right.value
            );

            this.onSlidingEvent.emit(sliderValue);
        });
    }

    updateSliderData() {
        this.renderer.addClass(this.slider, 'slider');

        this.renderer.addClass(this.track, 'track');
        this.renderer.setAttribute(
            this.track,
            'default-min',
            this.defaultValues.min
        );
        this.renderer.setAttribute(
            this.track,
            'default-max',
            this.defaultValues.max
        );

        this.renderer.addClass(this.range, 'range');

        this.renderer.addClass(this.relevant_range, 'relevant-range');
        this.renderer.addClass(this.rel_guide, 'relevant-range-guide');

        this.renderer.setAttribute(
            this.relevant_range,
            'relevant-min',
            this.relevantValues.min
        );
        this.renderer.setAttribute(
            this.relevant_range,
            'relevant-max',
            this.relevantValues.max
        );
        var percent_relevant_left =
            ((this.relevantValues.min - this.defaultValues.min) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        this.relevant_range.style.left = percent_relevant_left + '%';

        var percent_relevant_right =
            ((this.defaultValues.max - this.relevantValues.max) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        this.relevant_range.style.right = percent_relevant_right + '%';

        this.renderer.addClass(this.selected_range_min, 'selected-range-min');
        this.renderer.addClass(this.selected_range_max, 'selected-range-max');

        this.renderer.addClass(this.thumb_left, 'thumb');
        this.renderer.addClass(this.thumb_left, 'left');
        this.renderer.setAttribute(
            this.thumb_left,
            'data-min',
            this.newSelectionValues.min
        );
        var percent_left =
            ((this.newSelectionValues.min - this.defaultValues.min) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        this.thumb_left.style.left = percent_left + '%';
        this.range.style.left = percent_left + '%';

        this.renderer.addClass(this.thumb_right, 'thumb');
        this.renderer.addClass(this.thumb_right, 'right');
        this.renderer.setAttribute(
            this.thumb_right,
            'data-max',
            this.newSelectionValues.max
        );
        var percent_right =
            ((this.newSelectionValues.max - this.defaultValues.min) /
                (this.defaultValues.max - this.defaultValues.min)) *
            100;
        this.thumb_right.style.right = 100 - percent_right + '%';
        this.range.style.right = 100 - percent_right + '%';

        this.renderer.removeClass(this.thumb_left, 'hidden');
        this.renderer.removeClass(this.thumb_right, 'hidden');
        this.renderer.removeClass(this.relevant_range, 'hidden');

        if (
            this.newSelectionValues.min == -999 &&
            this.newSelectionValues.max == -999
        ) {
            this.renderer.addClass(this.thumb_left, 'hidden');
            this.renderer.addClass(this.thumb_right, 'hidden');
            this.renderer.addClass(this.relevant_range, 'hidden');
        }

        if (!this.userSelection) {
            this.updateLeftPos(this.newSelectionValues.value);

            this.renderer.setAttribute(
                this.selected_range_min,
                'data-selected-min',
                this.oldSelectionValues.min
            );
            this.renderer.setAttribute(
                this.selected_range_max,
                'data-selected-max',
                this.oldSelectionValues.max
            );

            percent_left =
                ((this.oldSelectionValues.min - this.defaultValues.min) /
                    (this.defaultValues.max - this.defaultValues.min)) *
                100;

            percent_right =
                ((this.oldSelectionValues.max - this.defaultValues.min) /
                    (this.defaultValues.max - this.defaultValues.min)) *
                100;

            this.selected_range_min.style.left = percent_left + '%';
            this.selected_range_max.style.right = 100 - percent_right + '%';
        }

        this.renderer.appendChild(this.slider, this.track);
        this.renderer.appendChild(this.slider, this.range);
        this.renderer.appendChild(this.slider, this.relevant_range);
        this.renderer.appendChild(this.relevant_range, this.rel_guide);

        this.renderer.appendChild(this.slider, this.selected_range_min);
        this.renderer.appendChild(this.slider, this.selected_range_max);

        this.renderer.appendChild(this.slider, this.thumb_left);
        this.renderer.appendChild(this.slider, this.thumb_right);

        this.renderer.setAttribute(this.range_left, 'type', 'range');
        this.renderer.setAttribute(
            this.range_left,
            'min',
            this.defaultValues.min
        );
        this.renderer.setAttribute(
            this.range_left,
            'max',
            this.defaultValues.max
        );
        this.renderer.setAttribute(this.range_left, 'step', '1');
        this.renderer.addClass(this.range_left, 'input-left');
        this.range_left.value = this.newSelectionValues.min;

        this.renderer.setAttribute(this.range_right, 'type', 'range');
        this.renderer.setAttribute(
            this.range_right,
            'min',
            this.defaultValues.min
        );
        this.renderer.setAttribute(
            this.range_right,
            'max',
            this.defaultValues.max
        );
        this.renderer.setAttribute(this.range_right, 'step', '1');
        this.renderer.addClass(this.range_right, 'input-right');
        this.range_right.value = this.newSelectionValues.max;

        this.elementRef.nativeElement.style = 'display:none';
        this.renderer.appendChild(
            this.renderer.parentNode(this.elementRef.nativeElement),
            this.range_left
        );
        this.renderer.appendChild(
            this.renderer.parentNode(this.elementRef.nativeElement),
            this.range_right
        );
        this.renderer.appendChild(
            this.renderer.parentNode(this.elementRef.nativeElement),
            this.slider
        );
    }

    updateLeftPos(value: number) {
        var left = '-20px';

        if (value < 10) {
            left = '-20px';
        }

        if (value >= 10 && value < 100) {
            left = '-25px';
        }

        if (value >= 100 && value < 1000) {
            left = '-30px';
        }

        if (value >= 1000 && value < 10000) {
            left = '-35px';
        }

        document.documentElement.style.setProperty(
            '--pseudo-selected-min-left',
            left
        );
    }
}
